import React from 'react';
import UploadSpendCubeForm from './UploadSpendCubeForm';
import Section from '../components/Section';
import { FileArchiveTable } from '../components/FileArchiveTable';
import { FileArchiveContext } from 'contexts/FileArchiveContext';
import { ApiDataContext } from 'contexts/ApiDataContext';
import LatestUpdateAlert from '../components/LatestUpdateAlert';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import {
	UploadTitle,
	UploadTitleDescription,
	Wrapper,
	UploadControlsSection,
} from './OverwriteSpendCube.styles';
import { LoaderWrapper, ScrollContainer } from '../Data.styles';

class UploadRawDataSection extends React.Component {
	render() {
		const { fileArchive, clearApiCache } = this.props;

		if (!fileArchive) {
			return (
				<LoaderWrapper>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</LoaderWrapper>
			);
		}

		const lastUploadedFile =
			fileArchive && fileArchive[0] ? fileArchive[0] : null;

		return (
			<ScrollContainer>
				<Wrapper>
					<UploadControlsSection>
						<LatestUpdateAlert
							type={lastUploadedFile ? lastUploadedFile.fileType : null}
							user={lastUploadedFile ? lastUploadedFile.userName : null}
							date={lastUploadedFile ? lastUploadedFile.date : null}
						/>
					</UploadControlsSection>
					<UploadTitle>Upload Spendcube</UploadTitle>
					<UploadTitleDescription>
						Current data will be overwritten with the data from the uploaded
						file
					</UploadTitleDescription>
					<UploadSpendCubeForm clearApiCache={clearApiCache} />

					<Section title="File archive">
						{fileArchive && <FileArchiveTable data={fileArchive} />}
					</Section>
				</Wrapper>
			</ScrollContainer>
		);
	}
}

export default props => (
	<ApiDataContext.Consumer>
		{({ clearApiCache }) => (
			<FileArchiveContext.Consumer>
				{({ fileArchive }) => (
					<UploadRawDataSection
						{...props}
						fileArchive={fileArchive}
						clearApiCache={clearApiCache}
					/>
				)}
			</FileArchiveContext.Consumer>
		)}
	</ApiDataContext.Consumer>
);
